import {
  unref,
} from 'vue'

function useIsSet() {
  function isSet(data) {
    return typeof unref(data) !== 'undefined'
  }

  return { isSet }
}

export default useIsSet
